import gql from "graphql-tag";

export const entryFragment = gql`
  fragment entryFragment on EntryInterface {
    id
    uri
    slug
    title
    enabled
    typeHandle
    sectionHandle
    __typename
  }
`;

export type EntryFragment = {
  id: string;
  uri: string;
  slug: string;
  title: string;
  enabled: boolean;
  typeHandle: string;
  sectionHandle: string;
  __typename: string;
};
